import type { SeatKind } from '@core/tellent-types';

export class CompanySwitchStrategy {
  public switchCompany: (
    orgGuid: string | null,
    companyId?: string,
    fallbackApps?: SeatKind[],
  ) => void;
}
